export enum PageTypeAdditional {
  ASSET = 'asset',
}

export const VGTVCategory = {
  NEWS: 1,
  SPORT: 3,
  FOOTBALL: 52,
  ENTERTAINMENT: 100324,
  SPOTLIGHT: 5,
  VIRAL: 279,
  DOCUMENTARY: 121,
} as const;

export const ABCategory = {
  NEWS: 4,
  SPORT: 5,
  ENTERTAINMENT: 1530,
} as const;

export type Vendor = 'vgtv' | 'ab' | 'brandstudio';

declare module '@vgtv/api-client/lib/svp_asset' {
  export interface SvpAsset {
    provider: Vendor;
  }
}
